import { Helmet } from "react-helmet"

function Bih() {
    return (
        <div className="flex-container full-width flex-grow-1">
            <Helmet>
                <title>Korisni linkovi - BiH</title>
                <meta
                    name="description"
                    content="Korisni linkovi vezani za Bosnu i Hercegovinu"
                    data-react-helmet="true" 
                />
            </Helmet>
            <p className="full-width padding-2p static-page-container">
                <a target="_blank"
                    rel='noreferrer'
                    href="https://umhis.ba/"
                    className="full-width"    
                >
                    umhis.ba
                </a>
            </p>
        </div>
    )
}

export default Bih